import { useQuery } from "@tanstack/react-query";

import { getUserWalletGraphData } from "../components/Users/UserManager/UserWalletsGraph/userWalletGraphDataSource";

const normaliseDateParam = (date) => {
  if (!date) return "";

  if (Array.isArray(date)) {
    return date
      .map((value) => (value?.toISOString ? value.toISOString() : String(value)))
      .join("|");
  }

  if (date?.toISOString) {
    return date.toISOString();
  }

  return String(date);
};

export const useUserWalletGraph = ({ userId, date, startDate, endDate }) =>
  useQuery({
    queryKey: ["USER_WALLET_GRAPH", userId || "", normaliseDateParam(date), normaliseDateParam(startDate), normaliseDateParam(endDate)],
    queryFn: () => getUserWalletGraphData({ userId, date, startDate, endDate }),
    enabled: Boolean(userId),
    placeholderData: (previousData) => previousData,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });

export default useUserWalletGraph;
